import {
  ONBOARDING_GOOGLE_DRIVE_ENABLED,
  ONBOARDING_STEP_COUNT,
} from '@/constants/onboarding'

function redirectIfDriveOnboardingDisabled(_to, _from, next) {
  if (!ONBOARDING_GOOGLE_DRIVE_ENABLED) {
    next({ path: '/workspaces' })
    return
  }
  next()
}

/** Mark workspace setup screens so Back cannot reopen them after exit. */
const onboardingFlowMeta = {
  onboardingFlow: true,
  auth: true,
  allowAuthenticated: true,
}

export default [
  {
    path: '/',
    component: () => import('@/layouts/AuthLayout.vue'),
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('@/views/auth/login.vue'),
        meta: { title: 'Login', guest: true }
      },
      {
        path: 'signup',
        name: 'signup',
        component: () => import('@/views/auth/signup.vue'),
        meta: { title: 'Signup', guest: true }
      },
      {
        path: 'forgot-password',
        name: 'forgot-password',
        component: () => import('@/views/auth/forgot-password.vue'),
        meta: { title: 'Forgot Password', guest: true }
      },
      {
        path: 'reset-password',
        name: 'reset-password',
        component: () => import('@/views/auth/reset-password.vue'),
        meta: { title: 'Reset Password' }
      },
      {
        path: '/google/callback',
        name: 'google-callback',
        component: () => import('@/views/auth/google-callback.vue'),
        meta: { title: 'Login with Google' }
      },
      {
        path: '/google-drive/callback',
        name: 'google-drive-callback',
        component: () => import('@/views/auth/google-drive-callback.vue'),
        meta: { title: 'Google Drive Connection', auth: true }
      },
      {
        path: '/google-admin/callback',
        name: 'google-admin-callback',
        component: () => import('@/views/auth/google-admin-callback.vue'),
        meta: { title: 'Super Admin Google Drive', auth: true }
      },
      {
        path: '/account-setup',
        name: 'account-setup',
        component: () => import('@/views/auth/account-setup.vue'),
        meta: { title: 'Setup your account', guest: true }
      },
      {
        path: '/complete-your-registration',
        name: 'complete-your-registration',
        component: () => import('@/views/auth/complete-your-registration.vue'),
        meta: { title: 'Complete your registration' }
      },
      {
        path: '/invitation',
        name: 'invitation',
        component: () => import('@/views/accept-invitation.vue'),
        meta: { title: 'Accept invitation' }
      },
      {
        path: 'email-verification',
        name: 'email-verification',
        component: () => import('@/views/auth/email-verification.vue'),
        meta: { title: 'Email Verification' }
      },
      {
        path: 'verify-email',
        name: 'verify-email',
        component: () => import('@/views/auth/verify-email.vue'),
        meta: { title: 'Verifying Email' }
      },
    ]
  },
  {
    path: '/',
    component: () => import('@/layouts/BlankLayout.vue'),
    children: [
      {
        path: 'welcome',
        name: 'welcome',
        component: () => import('@/views/auth/welcome.vue'),
        meta: {
          title: 'Welcome to ComplyOne',
          auth: true,
          allowAuthenticated: true,
        }
      },
      {
        path: 'setup-workspace',
        name: 'setup-workspace',
        component: () => import('@/views/auth/setup-workspace.vue'),
        meta: { title: 'Set Up Your Workspace', ...onboardingFlowMeta }
      },
      {
        path: 'onboarding/company-overview',
        name: 'onboarding-company-overview',
        component: () => import('@/views/auth/onboarding/company-overview.vue'),
        meta: {
          title: `Company Overview — Step 1 of ${ONBOARDING_STEP_COUNT}`,
          ...onboardingFlowMeta,
        }
      },
      {
        path: 'onboarding/business-overview',
        name: 'onboarding-business-overview',
        component: () => import('@/views/auth/onboarding/business-overview.vue'),
        meta: {
          title: `Business Overview — Step 2 of ${ONBOARDING_STEP_COUNT}`,
          ...onboardingFlowMeta,
        }
      },
      {
        path: 'onboarding/cco-auditor',
        name: 'onboarding-cco-auditor',
        component: () => import('@/views/auth/onboarding/cco-auditor.vue'),
        meta: {
          title: `CCO & Auditor Designation — Step 3 of ${ONBOARDING_STEP_COUNT}`,
          ...onboardingFlowMeta,
        }
      },
      {
        path: 'onboarding/your-documents',
        name: 'onboarding-your-documents',
        component: () => import('@/views/auth/onboarding/your-documents.vue'),
        meta: {
          title: `Your Documents — Step 4 of ${ONBOARDING_STEP_COUNT}`,
          ...onboardingFlowMeta,
        }
      },
      {
        path: 'onboarding/google-drive',
        name: 'onboarding-google-drive',
        component: () => import('@/views/auth/onboarding/google-drive.vue'),
        beforeEnter: redirectIfDriveOnboardingDisabled,
        meta: {
          title: `Google Drive — Step 5 of ${ONBOARDING_STEP_COUNT}`,
          ...onboardingFlowMeta,
        }
      },
      {
        path: 'onboarding/complete',
        name: 'onboarding-complete',
        component: () => import('@/views/auth/onboarding/complete.vue'),
        meta: {
          title: 'Your Compliance Workspace Is Ready',
          auth: true,
          allowAuthenticated: true,
          ...onboardingFlowMeta,
        }
      },
      {
        path: 'onboarding/preparing',
        name: 'onboarding-preparing',
        component: () => import('@/views/auth/onboarding/preparing.vue'),
        meta: {
          title: 'Setting Up Your Workspace',
          auth: true,
          allowAuthenticated: true,
          ...onboardingFlowMeta,
        }
      },
    ]
  }
]
